import './scripts/common';
import {onFind} from "./libs/@elements/init-modules-in-scope";
import {find} from "./libs/@elements/dom-utils";

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]', function (element) {
    new Popover(element, {})
});

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]', function (element) {
    new Dropdown(element, {});
});

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]', function (element) {
    new Tab(element, {});
});

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as smoothScroll from './scripts/smooth-scroll';
smoothScroll.init({
    scrollOffset: 10
});

import * as payment from './scripts/payment';
payment.init();

import * as paymentAuthorize from './scripts/payment-authorize';
paymentAuthorize.init();

import * as paymentPending from './scripts/paymentPending';
paymentPending.init();

import * as ajaxShippingMethods from './scripts/ajaxShippingMethods';
ajaxShippingMethods.init();

import * as pwCheck from './scripts/pw-check';
pwCheck.init();

import * as ajaxForm from './libs/@elements/ajax-form';
ajaxForm.init();

import * as ajaxAddressModal from './scripts/ajaxAddressModal';
ajaxAddressModal.init();

import * as linkWithInputVal from './scripts/linkWithInputVal';
linkWithInputVal.init();

import * as submitForm from './scripts/submitForm';
submitForm.init();

import * as collapsingCheckbox from './scripts/collapsingCheckbox';
collapsingCheckbox.init();

import * as collapsingRadio from './scripts/collapsingRadio';
collapsingRadio.init();

import * as deliveryCheckoutForm from './scripts/deliveryCheckoutForm';
deliveryCheckoutForm.init();

import * as deliveryCheckoutFormGuest from './scripts/deliveryCheckoutFormGuest';
deliveryCheckoutFormGuest.init();

import * as swissModal from './scripts/swissModal';
swissModal.init();

import * as addressValidation from './scripts/addressValidation';
addressValidation.init();

import * as datepickerForm from './scripts/datepickerForm';
datepickerForm.init();

import * as datepicker from './libs/@elements/datepicker';
if (find('.js-datepicker')) {
    datepicker.init();
}

import * as plzValidation from './scripts/plz-validation';
plzValidation.init();

import * as availabilityModal from './scripts/availabilityModal';
availabilityModal.init();

import * as proAccess from './scripts/proAccess';
proAccess.init();

import * as loadContent from '../shared/contents/content'
loadContent.init()

import * as friendlyCaptchaV1 from './scripts/friendlyCaptchaV1';
friendlyCaptchaV1.init();